<!--
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-25 15:55:30
 * @LastEditTime: 2022-03-08 12:01:04
-->
<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.Monitor.setVariable')"
      :visible.sync="dialogVisible"
      center
      width="60%"
    >
      <div class="present-params">
        <div class="params-title">{{ $t("lang.Monitor.addedVariable") }}：</div>
        <div class="variable">
          <div
            v-for="(item, index) in presentParams"
            :key="item.index"
            class="variable-item"
          >
            <div class="variable-item_content">
              {{ item.name }}
            </div>
            <div class="variable-item_delete" @click="closeTag(item, index)">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
      </div>
      <el-table
        size="mini"
        id="out-table"
        :data="paramsList"
        row-key="index"
        ref="paramsTable"
        @selection-change="handleSelectionChange"
        :header-cell-style="{ background: '#e4f1ff' }"
        height="400"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="40"
          reserve-selection
        ></el-table-column>
        <el-table-column
          :label="$t('lang.variableList.seriableNumber')"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color: #409eff; font-size: 15px">
              {{ scope.$index + 1 }}</span
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.variableList.name')">
          <template slot-scope="scope">
            <span class="font-style"> {{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.variableList.unit')">
          <template slot-scope="scope">
            <span class="font-style"> {{ scope.row.unit | unitFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.varlist.terminalName')">
          <template slot-scope="scope">
            <span class="font-style"> {{ scope.row.dtuName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column :label="$t('lang.variableList.registerMode')" min-width="120px">
          <template slot-scope="scope">
            <span class="font-style" > {{registerTypeObj[scope.row.registerType]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.variableList.registerAddress')" width="120px">
          <template slot-scope="scope">
            <span class="font-style" > {{scope.row|address}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="寄存器个数">
          <template slot-scope="scope">
            <span class="font-style"> {{scope.row.registerNum}}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column :label="$t('lang.variableList.dataType')" min-width="100px">
          <template slot-scope="scope">
            <span class="font-style"> {{dataTypeObj[scope.row.dataType]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.variableList.byteOrder')" min-width="100px">
          <template slot-scope="scope">
            <span class="font-style"> {{endianObj[scope.row.endian]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.variableList.triggerType')" min-width="100px">
          <template slot-scope="scope">
            <span class="font-style"> {{triggerObj[scope.row.trigger]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.variableList.triggerPeriod')" min-width="120px">
          <template slot-scope="scope">
            <span class="font-style"> {{scope.row.interval+'秒'}}</span>
          </template>
        </el-table-column> 
        <el-table-column
          :label="$t('lang.variableList.calculationFactor') + '(倍数)'"
          min-width="130px"
        >
          <template slot-scope="scope">
            <span class="font-style"> {{ scope.row.factor }}</span>
          </template>
        </el-table-column>
      <el-table-column :label="$t('lang.variableList.decimalPrecision')" min-width="100px" prop="precision">
          <template slot-scope="scope">
            <span class="font-style"> {{scope.row.precision}}</span>
          </template>
        </el-table-column> -->
      </el-table>
      <div slot="footer">
        <el-button size="mini" @click="dialogVisible = false">{{$t('lang.Button.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="addParams"
          >{{$t('lang.collect.save')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDeviceParams,
  addParamsByDid,
  deleteParams,
} from "@/api/cloudMonitor/dashboard";
import { PublicComponent } from "@/mixins/common";
import pagination from "@/components/pagination";
import {
  registerTypeObj,
  dataFormatObj,
  storageModeObj,
  rorwObj,
  dataTypeObj,
  endianObj,
  triggerObj,
  unitObj,
} from "@/utils/paramsConfig";
import device from "../../../../../../store/modules/device";
import { cloneDeep, isEqual } from "lodash";
export default {
  mixins: [PublicComponent],
  components: {
    pagination,
  },
  data() {
    return {
      dialogVisible: false,
      presentParams: [], // 目前已添加的变量
      copypresentParams: [], //复制copypresentParams
      paramsList: [],
      registerTypeObj,
      dataFormatObj,
      storageModeObj,
      unitObj,
      dataTypeObj,
      endianObj,
      rorwObj,
      triggerObj,
      deviceDid: "",
    };
  },
  filters: {
    address(e) {
      let prefix = "0";
      let str = "00000";
      switch (e.registerType) {
        case 1:
          str = "00000";
          prefix = "0";
          break;
        case 2:
          str = "10000";
          prefix = "1";
          break;
        case 3:
          str = "40000";
          prefix = "4";
          break;
        case 4:
          str = "30000";
          prefix = "3";
          break;
        default:
          str = "00000";
          prefix = "0";
      }
      let addrStr = e.registerAddress.toString();
      if (addrStr.length >= 5) {
        return prefix + addrStr;
      } else {
        let l = str.length - addrStr.length;
        return str.slice(0, l) + addrStr;
      }
    },
  },
  filters: {
    unitFormat(e) {
      if (unitObj[e]) {
        return unitObj[e];
      } else {
        unitObj[e] = e;
        return unitObj[e];
      }
    },
  },
  methods: {
    clearData() {
      this.presentParams = []; // 目前已添加的变量
      this.copypresentParams = []; //复制copypresentParams
      this.paramsList = [];
    },
    show(deviceDid, params) {
      this.clearData();
      this.presentParams = cloneDeep(params);
      this.copypresentParams = cloneDeep(this.presentParams);
      this.dialogVisible = true;
      this.deviceDid = deviceDid;
      this.$nextTick(() => {
        // 获取变量
        getDeviceParams(deviceDid)
          .then((res) => {
            if (res.data.code === 0) {
              this.paramsList = res.data.data;
              // // 初始化表格选中
              if (this.presentParams && this.presentParams.length > 0) {
                this.presentParams.forEach((ele) => {
                  let row = this.paramsList.find((item) => {
                    return ele.index === item.index;
                    // return item.id === ele.id
                  });
                  if (row) {
                    this.$refs.paramsTable.toggleRowSelection(row);
                  }
                });
              } else {
                this.$refs.multipleTable.clearSelection();
              }
            }
          })
          .catch(() => {});
      });
    },
    //禁止第一行搜索栏选中
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    // 点击已添加变量中的删符号
    closeTag(ele, index) {
      this.$refs.paramsTable.toggleRowSelection(ele);
    },
    handleSelectionChange(array) {
      this.presentParams = []; // 已添加变量块显示需要
      this.presentParams = array;
      console.log( this.presentParams);
    },
    // 添加已有的变量到监控大屏中
    addParams() {
      // 查看是否有删除或添加
      let addSelections = []; // 存的是表格列表中的变量id(对应copypresentParams中的vid)
      let deleteSelections = []; // 存的是大屏中展示变量的id
      let addDtuIds = []; // 变量对应的终端id
      // 原来有后来没有的要删除
      this.copypresentParams.forEach((item) => {
        let variable = this.presentParams.find((ele) => {
          return ele.index === item.index;
          // return ele.id === item.id
        });
        if (variable == undefined) {
          deleteSelections.push(item.id);
        }
      });
      // 原来没有后来有的要添加
      this.presentParams.forEach((item) => {
        let variable = this.copypresentParams.find((ele) => {
          return ele.index === item.index;
          // return item.id === ele.id
        });
        if (variable == undefined) {
          addSelections.push(item.id);
          addDtuIds.push(item.dtuId);
        }
      });
      if (addSelections.length > 0) {
        let params = {
          deviceDid: this.deviceDid,
          vids: addSelections,
          dtuids: addDtuIds,
        };
        addParamsByDid(params)
          .then((res) => {
            if (res.data.code === 0) {
              this.$emit("updateParams");
              this.$message.success("保存成功！");
            } else {
              this.$message.error("保存失败！");
            }
          })
          .catch(() => {
            this.$message.error("请求失败，请重试！");
          });
      }
      if (deleteSelections.length > 0) {
        let params = {
          vids: deleteSelections,
        };
        deleteParams(params)
          .then((res) => {
            if (res.data.code === 0) {
              this.$emit("updateParams");
              this.$message.success("保存成功！");
            } else {
              this.$message.error("保存失败！");
            }
          })
          .catch(() => {
            this.$message.error("请求失败，请重试！");
          });
      }
      this.$emit("loding");
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped>
.font-style {
  font-size: 0.25rem;
}
.present-params {
  background-color: #f2f5fc;
  margin-bottom: 30px;
  padding: 20px;
  display: flex;
}
.variable {
  display: flex;
  flex-wrap: wrap;
}
.variable-item {
  margin-left: 20px;
  color: #606266;
  font-size: 16px;
  line-height: 25px;
  border: 1px solid #b0b0b6;
  padding: 10px;
  display: flex;
  margin-bottom: 10px;
}
.params-title {
  font-size: 16px;
  font-weight: bolder;
}
.variable-item_delete {
  cursor: pointer;
  margin-left: 30px;
}
</style>
